import classNames from "classnames";
import { useContext, useEffect, useState } from "react";
import { RouteComponentProps } from "react-router";

import Loader from "src/app/components/loader/Loader";
import Sidebar from "src/app/modules/calculator/components/calculation/Sidebar";
import Total from "src/app/modules/calculator/components/calculation/Total";
import { ProjectSystem } from "src/app/modules/calculator/types";
import Header from "src/app/modules/user-projects/Header";
import { ModalContext } from "src/contexts/ModalContext";
import { ApiResult } from "src/core/helpers/api/ApiResult";
import { ProjectResponse } from "src/core/models/projects";
import { ProjectsService } from "src/core/services/projects";

import calcCss from "../calculator/components/calculation/Calculation.module.css";
import projectCSS from "./Projects.module.css";

const Details = ({ match }: RouteComponentProps) => {
  const { userId }: any = match.params;
  const { projectId }: any = match.params;
  const [loading, setLoading] = useState(true);
  const [project, setProject] = useState<ProjectResponse>();
  const [selectedSystems, setSelectedSystems] = useState<Array<ProjectSystem>>([]);

  const modalData = useContext(ModalContext);

  useEffect(() => {
    if (loading) {
      ProjectsService.getById(projectId)
        .then((response: ProjectResponse) => {
          if (response?.projectSystems) {
            setProject(response);
            setSelectedSystems(response.projectSystems?.map((prSys) => Object.assign({}, prSys) as ProjectSystem));
          }
        })
        .catch((e: ApiResult) => {
          if (!modalData?.content?.contentSet) {
            modalData?.triggerError(e);
          }
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [loading, modalData, projectId]);

  return (
    <div className="u-pos-relative">
      <div className={classNames("u-flex", "u-col-sm-12", "u-col-xs-12", "u-bg-white", calcCss.calcWrap)}>
        <div className={classNames("u-col-xs-12", "u-col-sm-3", calcCss.sidebar, projectCSS.sidebarDesktop)}>
          <Sidebar
            activeSystemIndex={0}
            selectedSystems={selectedSystems}
            onSystemChange={() => {}}
            onSystemRename={() => {}}
            onSystemDuplicate={() => {}}
            onSystemDelete={() => {}}
            onSeeTotal={() => {}}
            totalActive={true}
            addSystemActive={false}
          />
        </div>
        {selectedSystems?.length > 0 && (
          <div className="u-col-xs-12 u-col-sm-10">
            {project && (
              <div className={classNames("u-pl5per", "u-pr5per", "u-bg-white", calcCss.totalSystems)}>
                <Header userId={userId} project={project} selectedSystems={selectedSystems} />
                <div className={classNames("u-col-xs-12", "u-col-sm-3", calcCss.sidebar, projectCSS.sidebarMobile)}>
                  <Sidebar
                    activeSystemIndex={0}
                    selectedSystems={selectedSystems}
                    onSystemChange={() => {}}
                    onSystemRename={() => {}}
                    onSystemDuplicate={() => {}}
                    onSystemDelete={() => {}}
                    onSeeTotal={() => {}}
                    totalActive={true}
                    addSystemActive={false}
                  />
                </div>
                <Total selectedSystems={selectedSystems} />
              </div>
            )}
          </div>
        )}
      </div>
      {loading && <Loader />}
    </div>
  );
};

export default Details;
